import React from 'react'
import styles from './CircularActionButton.module.css'

interface CircularActionButtonProps {
  onClick: (e: React.MouseEvent) => void
  icon: React.ReactNode
  ariaLabel: string
  id?: string
  hidden?: boolean
}

export const CircularActionButton = React.forwardRef<HTMLButtonElement, CircularActionButtonProps>(
  ({ onClick, icon, ariaLabel, id, hidden }, ref) => {
    return (
      <button
        ref={ref}
        id={id}
        onClick={onClick}
        className={`${styles.circularButton} cursor-pointer border-none padding-none margin-none`}
        type='button'
        aria-label={ariaLabel}
        hidden={hidden}
      >
        {icon}
      </button>
    )
  }
)
